import React, {useState, useEffect} from 'react';
import {useParams, Link} from 'react-router-dom';
import {VscLoading} from 'react-icons/vsc';
import {IoIosArrowBack} from 'react-icons/io';
import {BsFileEarmarkArrowDown} from 'react-icons/bs';
import app from './firebase';
import {motion} from 'framer-motion';

const SingleFolder = () => {
  const {folderName} = useParams();
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const getFolderFiles = async () => {
    const result = await app.storage.getFiles({
      folderName,
    });
    const resultArray = Object.values(result);

    let resultsWithUrls = await Promise.all(
      resultArray.map(async (single) => {
        const url = await app.storage.getURL({fileId: single.id});
        return {...single, url};
      })
    );
    resultsWithUrls.sort((a, b) => (a.file > b.file ? 1 : -1));
    setLoading(false);
    setFiles(resultsWithUrls);
  };
  useEffect(() => {
    getFolderFiles();
    console.log('done');
  }, []);
  const variants = {
    visible: {opacity: 1},
    hidden: {opacity: 0},
  };

  return (
    <div className="sds-wrapper">
      <h2>SDS - {folderName}</h2>
      <Link to="/" className="back">
        <IoIosArrowBack /> <span>Select a Country</span>
      </Link>
      {loading && (
        <div className="loading-wrapper">
          <VscLoading />
        </div>
      )}
      <ul className="file-list">
        {files.length > 0 &&
          files.map((single) => (
            <motion.li initial="hidden" animate="visible" variants={variants}>
              <a href={single.url} target="_blank">
                <BsFileEarmarkArrowDown /> <span>{single.file}</span>
              </a>
            </motion.li>
          ))}
      </ul>
    </div>
  );
};

export default SingleFolder;
